import PropTypes from 'prop-types';
import css from './user-header.module.scss';

function UserHeader({ image, title, subtitle }) {
  return (
    <div className={css.userHeaderContainer}>
      <div className={css.leftContainer}>
        {image && (
          <div className={css.imageContainer}>
            <img className={css.image} alt="user" src={image} />
          </div>
        )}
        <div>
          {title && <h2 className={css.heading}>{title}</h2>}
          {subtitle && (
            <h3 className={css.username}>
              <span>{subtitle}</span>
            </h3>
          )}
        </div>
      </div>
    </div>
  );
}

UserHeader.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default UserHeader;
